function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.7 11H8c0-2-1.6-5-2-5.8 1 .2 2 1.3 3 2.6L8 3.5c.8.5 1.8 2.2 2.4 4.3.4-2 1-3.7 1.8-4l-.4 4c1-2 2.2-3.3 3-3.8-.5 1-2 4.5-2 7h-2zm7 7H15c0-2-1.6-5-2-5.8 1 .2 2 1.3 3 2.6l-1-4.3c.8.5 1.8 2.2 2.4 4.3.4-2 1-3.7 1.8-4l-.4 4c1-2 2.2-3.3 3-3.8-.5 1-2 4.5-2 7h-2zm-10 2H5c0-2-1.6-5-2-5.8 1 .2 2 1.3 3 2.6l-1-4.3c.8.5 1.8 2.2 2.4 4.3.4-2 1-3.7 1.8-4l-.4 4c1-2 2.2-3.3 3-3.8-.5 1-2 4.5-2 7H8z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationGrassland = function SvgLocationGrassland(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationGrassland;